import {
    options_mailboxCleanup_Messages,
    options_mailboxCleanup_EmptyingText,
    options_mailboxCleanup_EmptyFolderLabel,
    options_mailboxCleanup_DeleteDate,
    options_mailboxCleanup_DeleteAll,
} from './StorageOptionFull.locstring.json';
import loc, { format } from 'owa-localize';
import { observer } from 'mobx-react-lite';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import { getCustomIcon } from 'owa-folders-common';
import { ControlIcons } from 'owa-control-icons';
import BaseFolderType from 'owa-service/lib/contract/BaseFolderType';
import emptySelectedFolder from '../util/emptySelectedFolder';
import { BulkActionSpinner, isBulkActionRunning } from 'owa-bulk-action-store';
import { TooltipHost, DirectionalHint } from 'office-ui-fabric-react/lib/Tooltip';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { IContextualMenuProps } from 'office-ui-fabric-react/lib/ContextualMenu';

const styles = require('./StorageRow.scss');

export interface StorageRowProps {
    folder: BaseFolderType;
    usedSpace: string;
}

export default observer(function StorageRow(props: StorageRowProps) {
    const { folder } = props;
    const iconName = getCustomIcon(folder.FolderId.Id, true);
    const numberOfItems = format(loc(options_mailboxCleanup_Messages), folder.TotalCount);
    const shouldRenderBulkAction = isBulkActionRunning(folder.FolderId.Id);
    const folderName = folder.DisplayName;

    const menuProps: IContextualMenuProps = {
        items: [
            {
                key: 'All',
                text: loc(options_mailboxCleanup_DeleteAll),
                onClick: () => {
                    emptySelectedFolder(folder);
                },
            },
            {
                key: '3 months ago',
                text: format(loc(options_mailboxCleanup_DeleteDate), 3),
                onClick: () => {
                    emptySelectedFolder(folder, 3);
                },
            },
            {
                key: '6 months ago',
                text: format(loc(options_mailboxCleanup_DeleteDate), 6),
                onClick: () => {
                    emptySelectedFolder(folder, 6);
                },
            },
            {
                key: '12 months ago',
                text: format(loc(options_mailboxCleanup_DeleteDate), 12),
                onClick: () => {
                    emptySelectedFolder(folder, 12);
                },
            },
        ],
    };

    return (
        <div className={styles.storageRowContainer} role="group" aria-label={folderName}>
            <Icon className={styles.iconContainer} iconName={iconName} />
            <div className={styles.storageRowContent}>
                <TooltipHost
                    directionalHint={DirectionalHint.topLeftEdge}
                    hostClassName={styles.tooltipHost}
                    content={folderName}>
                    <span className={styles.storageRowText}>{folderName}</span>
                </TooltipHost>
                <span className={styles.usedSpace}>{props.usedSpace}</span>
                <div className={styles.itemCount}>{numberOfItems}</div>
            </div>
            {!shouldRenderBulkAction && (
                <CommandButton
                    className={styles.emptyFolderButton}
                    text={loc(options_mailboxCleanup_EmptyFolderLabel)}
                    iconProps={{ iconName: ControlIcons.Delete, className: styles.emptyFolderIcon }}
                    menuProps={menuProps}
                />
            )}
            {shouldRenderBulkAction && (
                <div className={styles.emptyProgressContainer}>
                    <span className={styles.spinner}>
                        <BulkActionSpinner folderId={folder.FolderId.Id} folderName={folderName} />
                    </span>
                    <span className={styles.emptyingText}>
                        {loc(options_mailboxCleanup_EmptyingText)}
                    </span>
                </div>
            )}
        </div>
    );
});
